document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll(".banner-col-2 video");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play();
          } else {
            entry.target.pause();
            entry.target.currentTime = 0;
          }
        });
      },
      { threshold: 0.5 }
    );

    videos.forEach((video) => {
      observer.observe(video);
    });
  });